import { Link } from 'react-router-dom';
import { comics } from '@/mocks/manga';
import { featuredComics } from '@/mocks/featured';

export default function FeaturedSection() {
  const featured = featuredComics.map(id => comics.find(c => c.id === id)).filter(Boolean) as typeof comics;

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">编辑精选</h2>
            <p className="text-sm text-foreground-500 mt-1">编辑部精心挑选的优质漫画</p>
          </div>
          <Link to="/category/lianzai" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer">
            查看更多 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 古古漫画网`}
                  title={`${comic.title} - ${comic.tags.join(' ')}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${
                    comic.status === '连载' ? 'bg-accent-500/90 text-background-50' : 'bg-secondary-500/90 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                {comic.rating >= 9.5 && (
                  <div className="absolute top-2 right-2 px-1.5 py-0.5 rounded bg-primary-500/90 text-background-50 text-xs font-bold">
                    {comic.rating}
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {comic.author} · 更新至{comic.chapters}话
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}